import { ofType } from "redux-observable";
import { from } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { utilGrantRewards } from "../../../utils/utilGrantRewards";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { TypeActionGrantRewards } from "../../grant-rewards/actionGrantRewards";
import { TypeGrantRewards } from "../../grant-rewards/TypeGrantRewards";
import { actionInventoryInfoAddProfilePicture, actionInventoryInfoAddResource, } from "../../info/inventory/actionInventoryInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
export var epicStoreCollectChestReward = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionGrantRewards.Collect), filter(function () { return state$.value.grantRewards.rewardsType === TypeGrantRewards.Chest; }), switchMap(function () {
        var grantRewards = state$.value.grantRewards.rewards;
        var profilePictureRewards = grantRewards.profilePictureRewards, resourceRewards = grantRewards.resourceRewards, convertedSnippetsFromProfilePicture = grantRewards.convertedSnippetsFromProfilePicture;
        var isRewardProfilePictures = utilGrantRewards.isRewardProfilePictures(grantRewards);
        var isRewardSnippets = utilGrantRewards.isRewardSnippets(grantRewards);
        if (isRewardProfilePictures && !isRewardSnippets) {
            return from([
                actionModalClose(IdModal.CollectRewardsStore),
                actionInventoryInfoAddProfilePicture(profilePictureRewards),
            ]);
        }
        else {
            var uniqueAnimationId = utilGrantRewards.getUniqueAnimationId(grantRewards);
            var rewards = utilGrantRewards.getResourcesRewards(grantRewards);
            var inventoryRewards = isRewardSnippets
                ? convertedSnippetsFromProfilePicture
                : resourceRewards;
            return from([
                actionModalClose(IdModal.CollectRewardsStore),
                actionInventoryInfoAddResource(inventoryRewards),
                actionAddPelletsInScreenCenterAnimation(uniqueAnimationId, rewards),
            ]);
        }
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/epics/epicStoreCollectChestReward.ts
// module id = 2418
// module chunks = 3